import React from 'react';
import { Link } from 'react-router-dom';
import EastIcon from '@mui/icons-material/East';
import { BLOG_POSTS } from '../../data/blogPosts';

const HomeBlog: React.FC = () => (
  <section className="py-12 sm:py-20 bg-white overflow-hidden">
    <div className="container-main">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-4 mb-8 sm:mb-12">
        <div className="min-w-0">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-light text-primary leading-tight">
            Our Latest<br />Blogs
          </h2>
        </div>
        <div className="hidden md:flex gap-2">
          <button aria-label="Previous blog posts" className="w-12 h-12 flex items-center justify-center border border-gray-200 rounded-xl text-gray-400 hover:text-primary hover:border-primary transition-colors">
            <span className="text-xl leading-none rotate-180">{'˃'}</span>
          </button>
          <button aria-label="Next blog posts" className="w-12 h-12 flex items-center justify-center bg-[#2D3142] text-white rounded-xl hover:bg-primary transition-colors">
            <span className="text-xl leading-none">{'˃'}</span>
          </button>
        </div>
      </div>

      <div className="flex gap-4 sm:gap-6 lg:gap-8 overflow-x-auto pb-8 snap-x snap-mandatory hide-scrollbar scroll-pl-4 sm:scroll-pl-0">
        {BLOG_POSTS.map((post) => (
          <Link key={post.slug} to={`/blog/${post.slug}`}
            className="min-w-[260px] w-[260px] sm:min-w-[280px] sm:w-[280px] md:min-w-[340px] md:w-[340px] flex-shrink-0 flex flex-col snap-start group cursor-pointer animate-fade-in">
            <div className="w-full aspect-[4/3] overflow-hidden bg-gray-100 mb-6 relative rounded-[1.5rem]">
              <img src={post.img} alt={post.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out" />
            </div>
            <div className="px-1 flex flex-col flex-1">
              <p className="text-[10px] text-gray-400 font-semibold mb-3 tracking-wider">{post.category}</p>
              <h3 className="font-bold text-lg text-primary leading-snug mb-2 pr-4">{post.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed mb-5 flex-1 line-clamp-2">{post.excerpt}</p>
              <div className="flex items-center justify-between mt-auto pt-2">
                <span className="text-sm font-semibold text-gray-500 group-hover:text-primary transition-colors flex items-center gap-2">
                  Read Blog <EastIcon sx={{ fontSize: 16 }} className="group-hover:translate-x-1 transition-transform" />
                </span>
                <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-primary translate-y-[1px] translate-x-[-1px]">
                    <path d="M7 17l9.2-9.2M17 17V7H7" />
                  </svg>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="flex md:hidden justify-center gap-2 mt-4">
        {BLOG_POSTS.map((_, i) => (
          <div key={i} className={`w-2 h-2 rounded-full flex-shrink-0 ${i === 0 ? 'bg-primary' : 'bg-gray-200'}`} />
        ))}
      </div>
    </div>
  </section>
);

export default HomeBlog;
